import React from 'react';

// Resource rendering functions
export const createRenderCustomResource = () => {
    return (resource) => {
        if (!resource.styling) {
            return (
                <div className="resource-template-content">
                    <h5 className="resource-name">{resource.name}</h5>
                    <div className="resource-description">{resource.description}</div>
                </div>
            )
        } else if (resource.styling === 'person') {
            return (
                <div className="resource-template-content">
                    <div className="resource-name">{resource.name}</div>
                    <div className="resource-description">{resource.description}</div>
                </div>
            )
        } else if (resource.styling === 'header') {
            return (
                <div className="resource-header-content">
                    <h6 className="resource-header-name">{resource.name}</h6>
                </div>
            )
        }
    };
};

export const createRenderResourceHeader = () => {
    return () => {
        return (
            <div className="md-resource-header-template-title">
                <div className="md-resource-header-template-name">Room</div>
                <div className="md-resource-header-template-seats">Capacity</div>
            </div>
        )
    };
};

// Array utility functions
export const flattenArr = (arr, flat = []) => {
    for (let i = 0; i < arr.length; i++) {
        flat.push(arr[i]);
        if (arr[i].children && arr[i].children.length) {
            flat.pop() // remove headers from list
            flattenArr(arr[i].children, flat);
        }
    }
    return flat;
};

export const flattenArrAll = (arr, flat = []) => {
    for (let i = 0; i < arr.length; i++) {
        flat.push(arr[i]);
        if (arr[i].children && arr[i].children.length) {
            flattenArrAll(arr[i].children, flat);
        }
    }
    return flat;
};

// Mobile menu functions
export const createShowMobileMenu = (mobileShow, setMobileShow) => {
    return (e) => {
        setMobileShow(!mobileShow)
        let el1 = document.querySelectorAll(".motion-air-calendar .mbsc-timeline-resource-empty");
        let el2 = document.querySelectorAll(".motion-air-calendar .mbsc-timeline-resource-col");
        let el3 = document.querySelectorAll(".motion-air-calendar .mbsc-timeline-resources");
        let el4 = document.querySelectorAll(".motion-timeline-resource.mbsc-ios.mbsc-ltr");
        let el5 = document.querySelectorAll(".motion-air-calendar .mbsc-timeline-resource-bg.mbsc-flex-1-1.mbsc-ios");

        if (mobileShow === true) {
            el1.forEach(el => el.classList.add('mobile-menu-open'))
            el2.forEach(el => el.classList.add('mobile-menu-open'))
            el3.forEach(el => el.classList.add('mobile-menu-open'))
            el4.forEach(el => el.classList.add('mobile-menu-open-padding'))
            el5.forEach(el => el.classList.add('mobile-menu-open'))
        } else {
            el1.forEach(el => el.classList.remove('mobile-menu-open'))
            el2.forEach(el => el.classList.remove('mobile-menu-open'))
            el3.forEach(el => el.classList.remove('mobile-menu-open'))
            el4.forEach(el => el.classList.remove('mobile-menu-open-padding'))
            el5.forEach(el => el.classList.remove('mobile-menu-open'))
        }
    };
};

